import { TIconProps } from './utils';

export const CartIconHover = ({ className = '' }: TIconProps) => (
  <svg
    width='46'
    height='46'
    viewBox='0 0 46 46'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M23.575 5.75C20.1595 5.75 17.365 8.66114 17.365 12.2113V14.8739H12.535C11.9485 14.8739 11.5 15.3354 11.5 15.939V32.6248C11.5 35.5714 13.8115 37.95 16.675 37.95H30.475C33.3385 37.95 35.65 35.5714 35.65 32.6248V15.939C35.65 15.3354 35.2015 14.8739 34.615 14.8739H29.785V12.2113C29.785 8.66114 26.9905 5.75 23.575 5.75ZM19.435 12.2113C19.435 9.83269 21.298 7.8801 23.575 7.8801C25.852 7.8801 27.715 9.83269 27.715 12.2113V14.8739H19.435V12.2113ZM33.58 17.0395V32.6603C33.58 34.4353 32.2 35.8554 30.475 35.8554H16.675C14.95 35.8554 13.57 34.4353 13.57 32.6603V17.0395H17.365V18.8856C17.365 19.4891 17.8135 19.9507 18.4 19.9507C18.9865 19.9507 19.435 19.4891 19.435 18.8856V17.0395H27.715V18.8856C27.715 19.4891 28.1635 19.9507 28.75 19.9507C29.3365 19.9507 29.785 19.4891 29.785 18.8856V17.0395H33.58Z'
      fill='url(#paint0_linear_2181_47075)'
      stroke='url(#paint1_linear_2181_47075)'
      strokeWidth='0.4'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2181_47075'
        x1='9.43841'
        y1='-6.60581'
        x2='44.6753'
        y2='0.500917'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B36BFF' />
        <stop offset='1' stopColor='#5A75FF' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2181_47075'
        x1='9.43841'
        y1='-6.60581'
        x2='44.6753'
        y2='0.500917'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B36BFF' />
        <stop offset='1' stopColor='#5A75FF' />
      </linearGradient>
    </defs>
  </svg>
);
